module.exports = __webpack_public_path__ + "img/scope6.368d76e0.png";